import { SERVICE_NAME } from "@/config/serviceNames";
import { requests } from ".";
import { EntityType, Module } from "@/constants";

const AiWrapperService = {
  // Fetch company information using AI wrapper API
  fetchCompanyInfo: (companyId: string) => {
    
    return requests(SERVICE_NAME.AI_WRAPPER_API)
      .log({
        module: Module.AI_WRAPPER,
        entityType: EntityType.COMPANY,
        entityId: companyId,
      })
      .get(`plan/company/`, {
        params: {
            companyId: companyId
        }
      });
  },

  // Update referral code using AI wrapper API
  updateReferralCode: (companyId: string, referralCode: string) => {
    return requests(SERVICE_NAME.AI_WRAPPER_API)
      .log({
        module: Module.AI_WRAPPER,
        entityType: EntityType.COMPANY,
        entityId: companyId,
      })
      .patch(`plan/company/internal?companyId=${companyId}`, { affiliateCode: referralCode });
  },

  // Remove referral code using AI wrapper API
  removeReferralCode: (companyId: string) => {
    return requests(SERVICE_NAME.AI_WRAPPER_API)
      .log({
        module: Module.AI_WRAPPER,
        entityType: EntityType.COMPANY,
        entityId: companyId,    
      })
      .patch(`plan/company/internal?companyId=${companyId}`, { affiliateCode: null });
  },

  // Get usage statistics with filters
  getUsageStats: (params: {
    locationIds?: string[];
    products?: string[];
    startDate?: string;
    endDate?: string;
    page?: number;
    limit?: number;
  }) => {
    // Build query params - handle arrays properly
    const queryParams: any = {};
    if (params.locationIds && params.locationIds.length > 0) {
      queryParams.locationIds = params.locationIds;
    }
    if (params.products && params.products.length > 0) {
      queryParams.products = params.products;
    }
    if (params.startDate) {
      queryParams.startDate = params.startDate;
    }
    if (params.endDate) {
      queryParams.endDate = params.endDate;
    }
    if (params.page) {
      queryParams.page = params.page;
    }
    if (params.limit) {
      queryParams.limit = params.limit;
    }
    return requests(SERVICE_NAME.AI_WRAPPER_API)
      .log({
        module: Module.AI_WRAPPER,
        entityType: EntityType.LOCATION,
        entityId: params.locationIds?.[0] || 'multiple',
      })
      .get('usage-stats', { params: queryParams });
  },

  // Get analytics data with filters
  getAnalytics: (params: {
    type: string;
    locationIds?: string[];
    companyIds?: string[];
    relationshipNumbers?: string[];
    products?: string[];
    startDate?: string;
    endDate?: string;
    page?: number;
    limit?: number;
  }) => {
    // Build query params - handle arrays properly
    const queryParams: any = {
      type: params.type
    };
    if (params.locationIds && params.locationIds.length > 0) {
      queryParams.locationIds = params.locationIds;
    }
    if (params.companyIds && params.companyIds.length > 0) {
      queryParams.companyIds = params.companyIds;
    }
    if (params.relationshipNumbers && params.relationshipNumbers.length > 0) {
      queryParams.relationshipNumbers = params.relationshipNumbers;
    }
    if (params.products && params.products.length > 0) {
      queryParams.products = params.products;
    }
    if (params.startDate) {
      queryParams.startDate = params.startDate;
    }
    if (params.endDate) {
      queryParams.endDate = params.endDate;
    }
    if (params.page) {
      queryParams.page = params.page;
    }
    if (params.limit) {
      queryParams.limit = params.limit;
    }

    return requests(SERVICE_NAME.AI_WRAPPER_API)
      .log({
        module: Module.AI_WRAPPER,
        entityType: EntityType.LOCATION,
        entityId: params.locationIds?.[0] || params.companyIds?.[0] || 'multiple',
      })
      .get('analytics', { params: queryParams });
  },
};

export default AiWrapperService; 